import React from 'react';
import styled from 'styled-components';

import {
    CardTitle, ErrCard,
    LastCardItem, SucCard,
} from '../SubPhaseStages/SubPhaseStages';
import FadeInAnimation from '../../../common/FadeInAnimation/FadeInAnimation';
import { DiscussBtn, RepeatBtn } from '../Phases/Buttons';
import { FontWeight } from '../../../utils/fonts';
import typograf from '../../../utils/typograf';

import CloseIcn from '../assets/close-icn.png';
import SucIcn from '../assets/suc-black-icn.svg';
import ErrIcn from '../assets/err-white-icn.svg';

class MobileNextPhase extends React.PureComponent {
    render() {
        const {
            results, risks, handleClosePopUp,
            openForm, next,
        } = this.props;
        return (
            <Container>
                <CloseButton src={CloseIcn} onClick={handleClosePopUp} />
                <Content>
                    <div>
                        <SucCard isActive>
                            <CardTitle>{typograf.execute('Для перехода к следующе&shy;му нужно:')}</CardTitle>
                            <div>
                                {results.map((result, index) => (
                                    <LastCardItem key={index.toString()}>
                                        <img alt="icn" src={SucIcn} />
                                        <div>{typograf.execute(result)}</div>
                                    </LastCardItem>
                                ))}
                            </div>
                        </SucCard>
                        <ErrCard isActive>
                            <CardTitle>{typograf.execute('риски, если пропустить:')}</CardTitle>
                            <div>
                                {risks.map((risk, index) => (
                                    <LastCardItem key={index.toString()}>
                                        <img alt="icn" src={ErrIcn} />
                                        <div>{typograf.execute(risk)}</div>
                                    </LastCardItem>
                                ))}
                            </div>
                        </ErrCard>
                    </div>
                    <FadeInAnimation delay="0.2" duration="0.5">
                        <DiscussBtn
                            onClick={openForm}
                        >
                            Обсудить задачу
                        </DiscussBtn>
                    </FadeInAnimation>
                    <FadeInAnimation delay="0.2" duration="0.5">
                        <RepeatBtn
                            onClick={() => { next(); handleClosePopUp('toTop', false); }}
                        >
                            ок, продолжить
                        </RepeatBtn>
                    </FadeInAnimation>
                </Content>
            </Container>
        );
    }
}

const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #FFF;
  
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
`;

const CloseButton = styled.img`
  width: 20px;
  height: 20px;
  
  position: absolute;
  top: 16px;
  right: 16px;
  
  cursor: pointer;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  
  align-items: center;
  
  align-self: center;
  ${FontWeight.REGULAR};
  padding: 20px 0;
`;


export default MobileNextPhase;
